import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/emails/';

class EmailsEnviadosService{
	constructor(){
		LoginService.currentUser.subscribe(data => {
			this.headers = {
				'Content-Type':'application/json',
				'authorization':'Bearer ' + (data ? data.token:'')
			};
		});
	}

  findAllEmailsEnviados(idContribuinte, dataIni, dataFin, tipoEmail){
    return axios.get(API_URL
      +'allEmailsEnviados?idContribuinte='+idContribuinte
      +'&dataIni='+dataIni
      +'&dataFin='+dataFin
			+'&tipoEmail='+tipoEmail, {headers: this.headers}).then(response => (this.data = response.data));
  }

	findTipoEmail(filtro){
		return axios.get(API_URL+'allTipoEmail?filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data));
	}
}
export default new EmailsEnviadosService();